// extracted by mini-css-extract-plugin
module.exports = {"tags":"TagList-tags-3RKDW"};